import { render, staticRenderFns } from "./client_space_app.vue?vue&type=template&id=1d1e1a15&scoped=true"
import script from "./client_space_app.vue?vue&type=script&lang=js"
export * from "./client_space_app.vue?vue&type=script&lang=js"
import style0 from "./client_space_app.vue?vue&type=style&index=0&id=1d1e1a15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1e1a15",
  null
  
)

export default component.exports